import { render, staticRenderFns } from "./LayoutProperty.vue?vue&type=template&id=3a491c47&scoped=true"
import script from "./LayoutProperty.vue?vue&type=script&lang=js"
export * from "./LayoutProperty.vue?vue&type=script&lang=js"
import style0 from "./LayoutProperty.vue?vue&type=style&index=0&id=3a491c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a491c47",
  null
  
)

export default component.exports